import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import { CurrentContractListItemProposedStepActionType } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, number, object, string } from "yup";
import { type AssetAllocationFields, createAssetAllocationSchema } from "../helpers";

export type PensionFormType = AssetAllocationFields & {
  readonly investmentToolType: string;
  readonly institution?: string;
  readonly clientId: string;
  readonly fund: string;
  readonly currentValue: number;
  readonly regularAmount: number;
  readonly employerDeposit?: number;
  readonly appreciationRate: number;
  readonly strategy: string;
  readonly horizon: number;
  readonly stateContribution?: number;
  readonly managementFee?: number;
  readonly proposedStepAction: string;
  readonly newDeposit?: number;
  readonly newRegularDeposit?: number;
  readonly note?: string;
};

export const getPensionFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
  requireCharacteristics?: boolean,
) => ObjectSchema<PensionFormType> = (t, requireCharacteristics) => {
  return object({
    investmentToolType: string().required(t(Resources.Validation.Required)),
    institution: string().optional(),
    clientId: string().required(t(Resources.Validation.Required)),
    fund: string().required(t(Resources.Validation.Required)),
    currentValue: number().required(t(Resources.Validation.Required)),
    regularAmount: number().required(t(Resources.Validation.Required)),
    horizon: number().required(t(Resources.Validation.Required)),
    employerDeposit: number().optional(),
    appreciationRate: number().required(t(Resources.Validation.Required)).max(100, t(Resources.Validation.PercentMax)),
    strategy: string().required(t(Resources.Validation.Required)),
    stateContribution: number().optional(),
    managementFee: number().optional().max(100, t(Resources.Validation.PercentMax)),
    ...createAssetAllocationSchema(t, requireCharacteristics),
    proposedStepAction: string().required(t(Resources.Validation.Required)),
    newDeposit: number().test("conditional-required", t(Resources.Validation.Required), function (value) {
      const { proposedStepAction } = this.parent;
      if (proposedStepAction === CurrentContractListItemProposedStepActionType.Modify) {
        return value !== undefined && value !== null;
      }
      return true;
    }),
    newRegularDeposit: number().test("conditional-required", t(Resources.Validation.Required), function (value) {
      const { proposedStepAction } = this.parent;
      if (proposedStepAction === CurrentContractListItemProposedStepActionType.Modify) {
        return value !== undefined && value !== null;
      }
      return true;
    }),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
  }).defined();
};
